import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaQuestionCircle, FaMotorcycle, FaMapMarkerAlt, FaWhatsapp, FaCheckCircle, FaWallet } from 'react-icons/fa';
import { ROLES } from '../../constants';

const SupportModal = ({ show, onHide, role }) => {
  const isDriver = role === ROLES.DRIVER;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold d-flex align-items-center">
          <FaQuestionCircle className="me-2 text-primary" style={{ color: 'var(--bry-cyan)' }} /> Centro de Ayuda
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4 pt-3">
        <h6 className="fw-bold mb-3">{isDriver ? 'Guía Rápida para Conductores' : 'Guía Rápida para Pasajeros'}</h6>
        
        <div className="help-steps mb-4">
          {isDriver ? (
            <>
              <div className="d-flex gap-3 mb-3">
                <div className="icon-step"><FaMotorcycle color="var(--bry-accent)" /></div>
                <div>
                  <div className="fw-bold small">1. Configura tu Vehículo</div>
                  <div className="text-muted extra-small">Asegúrate de registrar los datos de tu vehículo en tu Perfil antes de arrancar.</div>
                </div>
              </div>
              <div className="d-flex gap-3 mb-3">
                <div className="icon-step"><FaMapMarkerAlt color="var(--bry-accent)" /></div>
                <div>
                  <div className="fw-bold small">2. Actívate en el Mapa</div>
                  <div className="text-muted extra-small">Cambia tu estado a "Disponible" para empezar a recibir solicitudes de servicios.</div>
                </div>
              </div>
              <div className="d-flex gap-3">
                <div className="icon-step"><FaWallet color="var(--bry-accent)" /></div>
                <div>
                  <div className="fw-bold small">3. Completa y Cobra</div>
                  <div className="text-muted extra-small">Finaliza el viaje en la app, cobra tu tarifa y el sistema descontará la comisión automáticamente.</div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="d-flex gap-3 mb-3">
                <div className="icon-step"><FaMapMarkerAlt color="var(--bry-accent)" /></div>
                <div>
                  <div className="fw-bold small">1. Solicita un Servicio</div>
                  <div className="text-muted extra-small">Ingresa tu ubicación y tu destino para calcular la tarifa estimada.</div>
                </div>
              </div>
              <div className="d-flex gap-3 mb-3">
                <div className="icon-step"><FaMotorcycle color="var(--bry-accent)" /></div>
                <div>
                  <div className="fw-bold small">2. Espera a tu Conductor</div>
                  <div className="text-muted extra-small">Te asignaremos el conductor más cercano y podrás ver su ubicación en tiempo real.</div>
                </div>
              </div>
              <div className="d-flex gap-3">
                <div className="icon-step"><FaCheckCircle color="var(--bry-accent)" /></div>
                <div>
                  <div className="fw-bold small">3. Viaja Seguro</div>
                  <div className="text-muted extra-small">Comparte tu viaje si lo deseas. Al llegar, paga al conductor y califica tu experiencia.</div>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="bg-light p-3 rounded text-center mt-4">
          <div className="fw-bold small mb-2">¿Necesitas ayuda adicional?</div>
          <p className="text-muted extra-small mb-3">Nuestro equipo de soporte está disponible para resolver cualquier inconveniente.</p>
          <Button 
            variant="success" 
            className="w-100 rounded-pill fw-bold border-0 d-flex justify-content-center align-items-center" 
            onClick={() => window.open(process.env.REACT_APP_WHATSAPP_LINK || 'https://wa.me/5800000000000', '_blank')}
          >
            <FaWhatsapp className="me-2 fs-5" /> Contactar por WhatsApp
          </Button>
        </div>

      </Modal.Body>
      <style>{`
        .icon-step {
          width: 36px; height: 36px; border-radius: 50%; background: var(--bry-cyan-light);
          display: flex; align-items: center; justify-content: center; flex-shrink: 0;
          font-size: 16px;
        }
        .extra-small { font-size: 12px; line-height: 1.4; }
      `}</style>
    </Modal>
  );
};

export default SupportModal;
